import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const SetsIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 21 14" {...props}>
      <path
        d="M4.84615 0C4.40129 0 4.03846 0.369945 4.03846 0.823529V13.1765C4.03846 13.6301 4.40129 14 4.84615 14H6.46154C6.9064 14 7.26923 13.6301 7.26923 13.1765V8.23529H13.7308V13.1765C13.7308 13.6301 14.0936 14 14.5385 14H16.1538C16.5987 14 16.9615 13.6301 16.9615 13.1765V0.823529C16.9615 0.369945 16.5987 0 16.1538 0H14.5385C14.0936 0 13.7308 0.369945 13.7308 0.823529V5.76471H7.26923V0.823529C7.26923 0.369945 6.9064 0 6.46154 0H4.84615ZM2.42308 1.64706C1.97822 1.64706 1.61538 2.017 1.61538 2.47059V5.76471H0.807692C0.362831 5.76471 0 6.13465 0 6.58824V7.41176C0 7.86535 0.362831 8.23529 0.807692 8.23529H1.61538V11.5294C1.61538 11.983 1.97822 12.3529 2.42308 12.3529H3.23077V1.64706H2.42308ZM17.7692 1.64706V12.3529H18.5769C19.0218 12.3529 19.3846 11.983 19.3846 11.5294V8.23529H20.1923C20.6372 8.23529 21 7.86535 21 7.41176V6.58824C21 6.13465 20.6372 5.76471 20.1923 5.76471H19.3846V2.47059C19.3846 2.017 19.0218 1.64706 18.5769 1.64706H17.7692Z"
        fill={colors.grey}
      />
    </SvgIcon>
  );
};

export default SetsIcon;
